import Pill from "../Pill/Pill";
import styles from "./SectionHeader.module.css";
import { SectionHeaderProps } from "./SectionHeader.controller";

const SectionHeader = ({
  eyebrow,
  eyebrowVariant = "soft",
  title,
  description,
  className = "",
  alignment = "left",
}: SectionHeaderProps) => {
  const headerClassName = [
    styles.sectionHeader,
    alignment === "center" ? styles.centered : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={headerClassName}>
      {eyebrow ? <Pill label={eyebrow} variant={eyebrowVariant} /> : null}
      <h2 className={styles.title}>{title}</h2>
      {description ? <p className={styles.lede}>{description}</p> : null}
    </div>
  );
};

export default SectionHeader;
